<template>
  <div class="wrapper">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button v-if="searchStatus" status="my-orange" @click="searchStatus = false">隐藏查询</vxe-button>
        <vxe-button v-if="!searchStatus" status="my-orange" icon="fa fa-search" @click="searchStatus = true">查询</vxe-button>
      </template>
    </vxe-toolbar>
    <div v-if="searchStatus" class="search">
      <vxe-form title-align="right" title-width="120" title-colon :data="listQuery" @submit="handleSearch(true)" @reset="handleSearch(true, true)">
        <vxe-form-item title="姓名" span="6">
          <vxe-input v-model="listQuery.param.name" placeholder="请输入姓名" clearable />
        </vxe-form-item>
        <vxe-form-item title="联系方式" span="6">
          <vxe-input v-model="listQuery.param.phone" placeholder="请输入联系方式" clearable />
        </vxe-form-item>
        <vxe-form-item title="身份证号" span="6">
          <vxe-input v-model="listQuery.param.idNumber" placeholder="请输入身份证号" clearable />
        </vxe-form-item>
        <vxe-form-item title="性别" span="6">
          <vxe-select v-model="listQuery.param.gender" placeholder="请选择性别" clearable>
            <vxe-option
              v-for="(item, index) in genderArray"
              :key="index"
              :label="item"
              :value="index"
            />
          </vxe-select>
        </vxe-form-item>
        <vxe-form-item align="center" span="24">
          <vxe-button type="submit" status="my-orange" icon="fa fa-check">应用</vxe-button>
          <vxe-button type="reset" status="my-orange" icon="fa fa-undo">重置</vxe-button>
        </vxe-form-item>
      </vxe-form>
    </div>
    <CustomList ref="CustomList" :columns="tableColumns" :list-query="listQuery" @getList="getList">
      <template slot="operating" slot-scope="{row}">
        <el-button v-permission="'AuditRealNamePassButton'" size="small" type="text" @click="handleAudit(row.id, 1)">通过</el-button>
        <el-button v-permission="'AuditRealNameRejectButton'" size="small" type="text" @click="handleAudit(row.id, 2)">拒绝</el-button>
      </template>
    </CustomList>
    <Form ref="Form" @submit="handleSearch()" />
  </div>
</template>

<script>
import CustomList from '@/components/CustomList/index'
import { default as CustomTemplate } from '@/components/CustomList/CustomTemplate'
import { mapActions } from 'vuex'
export default {
  name: 'RealName',
  components: { CustomList, ...CustomTemplate },
  data() {
    return {
      searchStatus: false,
      genderArray: ['未知', '男', '女'],
      listQuery: {
        param: {
          certificationStatus: 2
        }
      },
      tableColumns: [
        {
          title: '姓名',
          formatter: (row, column) => {
            return row.pubUserHis ? row.pubUserHis.name : ''
          }
        },
        {
          title: '联系方式',
          formatter: (row, column) => {
            return row.pubUserHis ? row.pubUserHis.phone : ''
          }
        },
        {
          title: '身份证号',
          formatter: (row, column) => {
            return row.pubUserHis ? row.pubUserHis.idNumber : ''
          }
        },
        {
          title: '性别',
          formatter: (row, column) => {
            if (row.gender in this.genderArray) {
              return this.genderArray[row.gender]
            } else {
              return ''
            }
          }
        },
        {
          title: '是否老人',
          formatter: (row, column) => {
            return row.pubUserHis ? (row.pubUserHis.isOldPersion === 0 ? '否' : '是') : ''
          }
        },
        {
          title: '操作',
          fixed: 'right',
          slot: 'operating'
        }
      ]
    }
  },
  methods: {
    ...mapActions(['pubuserPageList', 'auditAudit']),
    handleSearch(resetCurrentPage = false, resetSearch = false) {
      if (resetSearch) {
        Object.assign(this.listQuery, this.$options.data.call(this).listQuery)
      }
      this.customListGetList(resetCurrentPage)
    },
    customListGetList(resetCurrentPage = false) {
      this.$refs.CustomList.getList(resetCurrentPage)
    },
    getList(params, callback) {
      this.pubuserPageList(params).then(response => {
        callback(response)
      }).catch(() => {})
    },
    handleAudit(mainId, status) {
      this.$confirm(`确认${status === 1 ? '通过' : '拒绝'}吗？`, '', {
        type: 'warning',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showInput: status === 2
      }).then(data => {
        let reason = ''
        if (typeof data === 'object' && 'value' in data) {
          reason = data.value
        }
        this.auditAudit({ type: 5, reason, mainId, status }).then(res => {
          if (res.code !== 200) {
            this.$message.error(res.msg)
            return
          }
          this.$message.success('操作成功')
          this.handleSearch(true)
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
  .wrapper{
    overflow: auto;
  }
</style>
